// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PojedinaObavijest_container__61Uv6 {
  flex-direction: column;
  align-items: baseline;
  gap: 16px;
  width: 100%;
  padding-bottom: 30px;
}
.PojedinaObavijest_container__61Uv6,
.PojedinaObavijest_backRow__pMZGk {
  display: flex;
  justify-content: center;
}
.PojedinaObavijest_singleRow__Jsmax {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.PojedinaObavijest_backRow__pMZGk {
  gap: 20px;
  transition: -webkit-text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out, -webkit-text-decoration 300ms ease-in-out;
  align-items: center;
}
.PojedinaObavijest_saveBtn__Nuwtz {
  background-color: #cb9c2d;
  border-radius: 4px;
  height: 52px;
  border: none;
  width: 212px;
  align-items: center;
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
  display: flex;
  justify-content: center;
  color: #ffffff;
  font-family: "Inter";
  margin: 0px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.PojedinaObavijest_saveBtn__Nuwtz:hover {
  background-color: #b98d26;
}
.PojedinaObavijest_saveBtn__Nuwtz:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}
.PojedinaObavijest_backRow__pMZGk:hover {
  text-decoration: underline;
  cursor: pointer;
}
.PojedinaObavijest_backSpan__CcxWf {
  font-weight: 600;
  font-size: 16px;
}
.PojedinaObavijest_backSpan__CcxWf,
.PojedinaObavijest_date__jnYsA {
  color: #5f6d7e;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  font-family: Inter;
}
.PojedinaObavijest_title__UYEAk {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  margin-top: 16px;
  margin-bottom: -12px;
}
.PojedinaObavijest_date__jnYsA {
  font-size: 14px;
  font-weight: 400;
}
.PojedinaObavijest_title__UYEAk,
.PojedinaObavijest_paragraph__9DUWC {
  color: #4d4d4d;
}
.PojedinaObavijest_paragraph__9DUWC {
  width: 75%;
}
.PojedinaObavijest_paragraph__9DUWC,
.PojedinaObavijest_link__5lRQb {
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
}
.PojedinaObavijest_link__5lRQb {
  color: #5f6d7e;
  margin-top: -16px;
}

.PojedinaObavijest_notAllowed__Mt4BM {
  display: flex;
  gap: 10px;
  background-color: #ffebeb;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  font-size: 15px;
  font-family: Inter;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #5f6d7e;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/PojedinaObavijest/PojedinaObavijest.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,SAAS;EACT,qDAA6C;EAA7C,6CAA6C;EAA7C,wFAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".container {\n  flex-direction: column;\n  align-items: baseline;\n  gap: 16px;\n  width: 100%;\n  padding-bottom: 30px;\n}\n.container,\n.backRow {\n  display: flex;\n  justify-content: center;\n}\n.singleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.backRow {\n  gap: 20px;\n  transition: text-decoration 300ms ease-in-out;\n  align-items: center;\n}\n.saveBtn {\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  height: 52px;\n  border: none;\n  width: 212px;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n  display: flex;\n  justify-content: center;\n  color: #ffffff;\n  font-family: \"Inter\";\n  margin: 0px;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.saveBtn:hover {\n  background-color: #b98d26;\n}\n.saveBtn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.backRow:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.backSpan {\n  font-weight: 600;\n  font-size: 16px;\n}\n.backSpan,\n.date {\n  color: #5f6d7e;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  font-family: Inter;\n}\n.title {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  margin-top: 16px;\n  margin-bottom: -12px;\n}\n.date {\n  font-size: 14px;\n  font-weight: 400;\n}\n.title,\n.paragraph {\n  color: #4d4d4d;\n}\n.paragraph {\n  width: 75%;\n}\n.paragraph,\n.link {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.link {\n  color: #5f6d7e;\n  margin-top: -16px;\n}\n\n.notAllowed {\n  display: flex;\n  gap: 10px;\n  background-color: #ffebeb;\n  width: 100%;\n  height: 40px;\n  border-radius: 6px;\n  font-size: 15px;\n  font-family: Inter;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n  color: #5f6d7e;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PojedinaObavijest_container__61Uv6`,
	"backRow": `PojedinaObavijest_backRow__pMZGk`,
	"singleRow": `PojedinaObavijest_singleRow__Jsmax`,
	"saveBtn": `PojedinaObavijest_saveBtn__Nuwtz`,
	"backSpan": `PojedinaObavijest_backSpan__CcxWf`,
	"date": `PojedinaObavijest_date__jnYsA`,
	"title": `PojedinaObavijest_title__UYEAk`,
	"paragraph": `PojedinaObavijest_paragraph__9DUWC`,
	"link": `PojedinaObavijest_link__5lRQb`,
	"notAllowed": `PojedinaObavijest_notAllowed__Mt4BM`
};
export default ___CSS_LOADER_EXPORT___;
